var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndoArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 83,
    viewBox: "0 0 63 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 51.5C3 57.1368 4.67149 62.6469 7.80311 67.3337C10.9347 72.0205 15.3858 75.6735 20.5935 77.8306C25.8012 79.9877 31.5316 80.5521 37.0601 79.4524C42.5885 78.3527 47.6667 75.6383 51.6525 71.6525C55.6383 67.6668 58.3527 62.5885 59.4524 57.0601C60.5521 51.5316 59.9877 45.8012 57.8306 40.5935C55.6735 35.3858 52.0206 30.9347 47.3338 27.8031C42.647 24.6715 37.1368 23 31.5 23",
    stroke: "#909099",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26C32.6569 26 34 24.6569 34 23C34 21.3431 32.6569 20 31 20V26ZM10.8787 20.8787C9.70711 22.0503 9.70711 23.9497 10.8787 25.1213L29.9706 44.2132C31.1421 45.3848 33.0416 45.3848 34.2132 44.2132C35.3848 43.0416 35.3848 41.1421 34.2132 39.9706L17.2426 23L34.2132 6.02944C35.3848 4.85786 35.3848 2.95837 34.2132 1.78679C33.0416 0.615221 31.1421 0.615221 29.9706 1.78679L10.8787 20.8787ZM31 20L13 20V26L31 26V20Z",
    fill: "#909099"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoArrow);
export default __webpack_public_path__ + "static/media/Undo-Arrow.f07a48cb6eb11d68b23905297e952663.svg";
export { ForwardRef as ReactComponent };